import styled from 'styled-components';

interface Props {}
const VBucksContentContainer = styled.div<Props>`
  display: flex;
  width: 100%;
  max-width: 1600px;
  height: 100%;
  position: relative;
  align-items: center;
  justify-content: flex-end;

  @media screen and (max-width: 975px) {
    flex-direction: column;
    justify-content: center;
  }
`;

export default VBucksContentContainer;
